import { LitElement, html, css } from 'lit';

class SearchResults extends LitElement {
    static get properties() {
        return {
            isLoading: {
                type: Boolean,
                attribute: 'is-loading',
                hasChanged(newVal, oldVal) {
                    return newVal !== oldVal;
                },
                converter: {
                    fromAttribute: (value, type) => {
                        if (value === 'true' || value === 'True' || value == '1' ) {
                            return true;
                        }
                        return false;
                    }
                }
            },
            errorMessage: {
                type: String,
                attribute: 'error-message',
                hasChanged(newVal, oldVal) {
                    return newVal !== oldVal;
                }
            }
        };
    }
    constructor() {
        super();
        this.isLoading = true;
    }

    static styles = css`
        .search-results {
            display: grid;
            grid-gap: 10px;
            margin-top: 1em;
        }
        
        @media only screen and (min-width: 920px) {
            .search-results {
                grid-template-columns: repeat(auto-fill, minmax(min(230px, 100%), 1fr));
                grid-template-rows: repeat(auto-fill, minmax(200px, 1fr));
            }
        }

        /* empty state */
        .empty-state {
            display: block;
            width: 100%;
            text-align: center;
            font-size: 1.4em;
            margin-top: 1em;
            margin-bottom: 1em;
            grid-column-start: 1;
            grid-column-end: 7;
        }

        /* loading state */
        .loading-state {
            display: flex;
            width: 100%;
            text-align: center;
            font-size: 1.4em;
            font-weight: bold;
            margin-top: 3em;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            grid-column-start: 1;
            grid-column-end: 7;
        }
        .loading-state svg {
            width: 25px;
            height: 25px;
            margin-right: 0.5em;
        }
        
        #loading-spinner {
            transform-origin: center;
            animation-name: animation;
            animation-duration: 1.2s;
            animation-timing-function: cubic-bezier;
            animation-iteration-count: infinite;
        }
        
        loading-element {
            grid-column-start: 3;
            grid-column-end: 5;
            margin-top: 1em;
            margin-bottom: 1em;
        }
        
        pagination-element {
            margin-top: 1em;
            margin-bottom: 1em;
        }
    `;

    render() {
        return html`
            <slot name="pagination_top"></slot>
            <div class="search-results">
                <slot name="results">
                    ${this.renderEmptyState()}
                </slot>
            </div>
            <slot name="pagination_bottom"></slot>
        `;
    }

    renderEmptyState() {
        if (this.errorMessage && this.errorMessage.length > 0) {
            return html`
                <div class="empty-state">
                    <h4>Error occured while fetching results</h4>
                    <p>${this.errorMessage}</p>
                </div>
            `;
        }

        if (this.isLoading) {
            return html`<loading-element></loading-element>`;
        }

        return html`
            <div class="empty-state">
                <h4>No projects found</h4>
                <p>Try adjusting your search terms.</p>
            </div>
        `;
    }
}

window.customElements.define('search-results', SearchResults);